<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-tit">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/ch1">Chief Left Hand</a></p>
<p class="toc"><a href="#/ch2">Major Edward Wynkoop</a></p>
<p class="toc"><span href="#/ch3" title="Link target outside of Sample">Governor John Evans</span></p>
<p class="toc"><span href="#/ch4" title="Link target outside of Sample">Captain Silas Soule</span></p>
<p class="toc"><span href="#/ch5" title="Link target outside of Sample">Chief One Eye</span></p>
<p class="toc"><span href="#/ch6" title="Link target outside of Sample">Colonel John Chivington</span></p>
<p class="toc"><span href="#/ch7" title="Link target outside of Sample">Lieutenant Joseph Cramer</span></p>
<p class="toc"><span href="#/ch8" title="Link target outside of Sample">Major Scott Anthony</span></p>
<p class="toc"><span href="#/ch9" title="Link target outside of Sample">Chief White Antelope</span></p>
<p class="toc"><span href="#/ch10" title="Link target outside of Sample">William Bent</span></p>
<p class="toc"><span href="#/ch11" title="Link target outside of Sample">Major Jacob Downing</span></p>
<p class="toc"><span href="#/ch12" title="Link target outside of Sample">Lieutenant James Cannon</span></p>
<p class="toc"><span href="#/ch13" title="Link target outside of Sample">Lieutenant Colonel Samuel F. Tappan</span></p>
<p class="toc"><span href="#/ch14" title="Link target outside of Sample">Chief Black Kettle</span></p>
<p class="toc1"><span href="#/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6397a6c4